<template>
  <figure class="mb-6">
    <div class="bg-gray-50 rounded-xl p-4">
      <img :src="url" :alt="alt" class="w-full rounded-lg border border-gray-200" />
    </div>
    <figcaption v-if="caption" class="mt-2 text-sm text-gray-500 text-center italic">
      {{ caption }}
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: "ImageSection",
  props: {
    url: { type: String, required: true },
    alt: { type: String, default: "" },
    caption: { type: String, default: "" },
  },
};
</script>
